"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Engineer = void 0;
const CardName_1 = require("../../CardName");
const Units_1 = require("../../Units");
const IAward_1 = require("../IAward");
class Engineer {
    constructor() {
        this.name = 'Engineer';
        this.description = 'Have the most cards that directly alter your own production';
    }
    getScore(player) {
        let score = player.playedCards.filter((card) => card.produce !== undefined || (card.productionBox !== undefined && card.productionBox !== Units_1.Units.EMPTY)).length;
        score += player.playedCards.filter((card) => Engineer.productionCards.includes(card.name)).length;
        player.corporationCards.forEach((corp) => {
            if (Engineer.productionCards.includes(corp.name))
                score += 1;
        });
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Engineer = Engineer;
Engineer.productionCards = [
    CardName_1.CardName.ACQUIRED_COMPANY,
    CardName_1.CardName.ADAPTED_LICHEN,
    CardName_1.CardName.AEROBRAKED_AMMONIA_ASTEROID,
    CardName_1.CardName.ALGAE,
    CardName_1.CardName.ARCHAEBACTERIA,
    CardName_1.CardName.ARTIFICIAL_PHOTOSYNTHESIS,
    CardName_1.CardName.ASTEROID_MINING,
    CardName_1.CardName.ASTEROID_MINING_CONSORTIUM,
    CardName_1.CardName.BEAM_FROM_A_THORIUM_ASTEROID,
    CardName_1.CardName.BLACK_POLAR_DUST,
    CardName_1.CardName.BUSHES,
    CardName_1.CardName.BUSINESS_NETWORK,
    CardName_1.CardName.CALLISTO_PENAL_MINES,
    CardName_1.CardName.CARTEL,
    CardName_1.CardName.CLOUD_SEEDING,
    CardName_1.CardName.DESIGNED_MICRO_ORGANISMS,
    CardName_1.CardName.ENERGY_SAVING,
    CardName_1.CardName.ENERGY_TAPPING,
    CardName_1.CardName.FARMING,
    CardName_1.CardName.GIANT_SPACE_MIRROR,
    CardName_1.CardName.GRASS,
    CardName_1.CardName.GREAT_ESCARPMENT_CONSORTIUM,
    CardName_1.CardName.HACKERS,
    CardName_1.CardName.HEATHER,
    CardName_1.CardName.IMMIGRATION_SHUTTLES,
    CardName_1.CardName.IMPORTED_GHG,
    CardName_1.CardName.IMPORT_OF_ADVANCED_GHG,
    CardName_1.CardName.INSECTS,
    CardName_1.CardName.INSULATION,
    CardName_1.CardName.IO_MINING_INDUSTRIES,
    CardName_1.CardName.KELP_FARMING,
    CardName_1.CardName.LICHEN,
    CardName_1.CardName.LIGHTNING_HARVEST,
    CardName_1.CardName.LIVESTOCK,
    CardName_1.CardName.LUNAR_BEAM,
    CardName_1.CardName.MASS_CONVERTER,
    CardName_1.CardName.METHANE_FROM_TITAN,
    CardName_1.CardName.MICRO_MILLS,
    CardName_1.CardName.MIRANDA_RESORT,
    CardName_1.CardName.MOSS,
    CardName_1.CardName.NITROGEN_RICH_ASTEROID,
    CardName_1.CardName.NITROPHILIC_MOSS,
    CardName_1.CardName.PHOBOS_SPACE_HAVEN,
    CardName_1.CardName.POWER_GRID,
    CardName_1.CardName.POWER_SUPPLY_CONSORTIUM,
    CardName_1.CardName.QUANTUM_EXTRACTOR,
    CardName_1.CardName.RAD_SUITS,
    CardName_1.CardName.SATELLITES,
    CardName_1.CardName.SHUTTLES,
    CardName_1.CardName.SOLAR_WIND_POWER,
    CardName_1.CardName.SOLETTA,
    CardName_1.CardName.SPONSORS,
    CardName_1.CardName.TOLL_STATION,
    CardName_1.CardName.TUNDRA_FARMING,
    CardName_1.CardName.TREES,
    CardName_1.CardName.VESTA_SHIPYARD,
    CardName_1.CardName.WAVE_POWER,
    CardName_1.CardName.WORMS,
    CardName_1.CardName.ZEPPELINS,
    CardName_1.CardName.ECOLINE,
    CardName_1.CardName.HELION,
    CardName_1.CardName.THORGATE,
    CardName_1.CardName.SATURN_SYSTEMS,
    CardName_1.CardName.CORRODER_SUITS,
    CardName_1.CardName.DAWN_CITY,
    CardName_1.CardName.FREYJA_BIODOMES,
    CardName_1.CardName.GHG_IMPORT_FROM_VENUS,
    CardName_1.CardName.ISHTAR_MINING,
    CardName_1.CardName.LUNA_METROPOLIS,
    CardName_1.CardName.MAXWELL_BASE,
    CardName_1.CardName.ORBITAL_REFLECTORS,
    CardName_1.CardName.SISTER_PLANET_SUPPORT,
    CardName_1.CardName.STRATOPOLIS,
    CardName_1.CardName.SULPHUR_EXPORTS,
    CardName_1.CardName.TERRAFORMING_CONTRACT,
    CardName_1.CardName.VENUS_GOVERNOR,
    CardName_1.CardName.VENUS_SOILS,
    CardName_1.CardName.APHRODITE,
    CardName_1.CardName.SPACE_HOTELS,
    CardName_1.CardName.POINT_LUNA,
    CardName_1.CardName.ALLIED_BANKS,
    CardName_1.CardName.AQUIFER_TURBINES,
    CardName_1.CardName.BIOFUELS,
    CardName_1.CardName.BIOLAB,
    CardName_1.CardName.BIOSPHERE_SUPPORT,
    CardName_1.CardName.BUSINESS_EMPIRE,
    CardName_1.CardName.ECOLOGY_EXPERTS,
    CardName_1.CardName.GALILEAN_MINING,
    CardName_1.CardName.IO_RESEARCH_OUTPOST,
    CardName_1.CardName.LOAN,
    CardName_1.CardName.METALS_COMPANY,
    CardName_1.CardName.NITROGEN_SHIPMENT,
    CardName_1.CardName.ORBITAL_CONSTRUCTION_YARD,
    CardName_1.CardName.POWER_GENERATION,
    CardName_1.CardName.SOCIETY_SUPPORT,
    CardName_1.CardName.SUPPLIER,
    CardName_1.CardName.AIRLINERS,
    CardName_1.CardName.COMMUNITY_SERVICES,
    CardName_1.CardName.CORONA_EXTRACTOR,
    CardName_1.CardName.EARTH_ELEVATOR,
    CardName_1.CardName.ECOLOGY_RESEARCH,
    CardName_1.CardName.FLOATER_LEASING,
    CardName_1.CardName.GALILEAN_WAYSTATION,
    CardName_1.CardName.HEAVY_TAXATION,
    CardName_1.CardName.LUNAR_EXPORTS,
    CardName_1.CardName.LUNA_GOVERNOR,
    CardName_1.CardName.LUNAR_MINING,
    CardName_1.CardName.MINING_COLONY,
    CardName_1.CardName.MINORITY_REFUGE,
    CardName_1.CardName.PIONEER_SETTLEMENT,
    CardName_1.CardName.QUANTUM_COMMUNICATIONS,
    CardName_1.CardName.SOLAR_REFLECTORS,
    CardName_1.CardName.URBAN_DECOMPOSERS,
    CardName_1.CardName.POLYPHEMOS,
    CardName_1.CardName.ARKLIGHT,
    CardName_1.CardName.AERIAL_LENSES,
    CardName_1.CardName.ASTEROID_DEFLECTION_SYSTEM,
    CardName_1.CardName.CASINOS,
    CardName_1.CardName.DUSK_LASER_MINING,
    CardName_1.CardName.HOSPITALS,
    CardName_1.CardName.INTERPLANETARY_TRADE,
    CardName_1.CardName.MONS_INSURANCE,
    CardName_1.CardName.NEW_HOLLAND,
    CardName_1.CardName.NEW_PARTNER,
    CardName_1.CardName.ORBITAL_CLEANUP,
    CardName_1.CardName.POTATOES,
    CardName_1.CardName.SNOW_ALGAE,
    CardName_1.CardName.SUPERMARKETS,
    CardName_1.CardName.ANTI_DESERTIFICATION_TECHNIQUES,
    CardName_1.CardName.CLOUD_TOURISM,
    CardName_1.CardName.COLONY_TRADE_HUB,
    CardName_1.CardName.CYBERIA_SYSTEMS,
    CardName_1.CardName.ECOTEC,
    CardName_1.CardName.FRONTIER_TOWN,
    CardName_1.CardName.GHG_SHIPMENT,
    CardName_1.CardName.GIANT_SOLAR_COLLECTOR,
    CardName_1.CardName.HERMETIC_ORDER_OF_MARS,
    CardName_1.CardName.HOMEOSTASIS_BUREAU,
    CardName_1.CardName.INDUSTRIAL_COMPLEX,
    CardName_1.CardName.KAGUYA_TECH,
    CardName_1.CardName.MARTIAN_LUMBER_CORP,
    CardName_1.CardName.MICROGRAVITY_NUTRITION,
    CardName_1.CardName.NIRGAL_ENTERPRISES,
    CardName_1.CardName.OLD_MINING_COLONY,
    CardName_1.CardName.RED_APPEASEMENT,
    CardName_1.CardName.RISE_TO_POWER,
    CardName_1.CardName.SAGITTA_FRONTIER_SERVICES,
    CardName_1.CardName.TYCHO_MAGNETICS,
    CardName_1.CardName.MARKETING_EXPERTS,
    CardName_1.CardName.AGRICOLA_INC,
    CardName_1.CardName.PLAYWRIGHTS,
    CardName_1.CardName.BOTANICAL_HARVEST,
    CardName_1.CardName.GEOTHERMAL_VENT,
    CardName_1.CardName.HYDROGEN_BOMBARDMENT,
    CardName_1.CardName.LASER_FACTORY,
    CardName_1.CardName.MICROALGAE,
    CardName_1.CardName.NITRATE_REDUCERS,
    CardName_1.CardName.SOLAR_BATTERIES,
    CardName_1.CardName.TRADE_INFRASTRUCTURE,
    CardName_1.CardName.ALGAE_BIOREACTORS,
    CardName_1.CardName.ARCHIMEDES_HYDROPONICS_STATION,
    CardName_1.CardName.ARISTARCHUS_ROAD_NETWORK,
    CardName_1.CardName.COPERNICUS_SOLAR_ARRAYS,
    CardName_1.CardName.DARKSIDE_MINING_SYNDICATE,
    CardName_1.CardName.DEEP_LUNAR_MINING,
    CardName_1.CardName.GEODESIC_TENTS,
    CardName_1.CardName.HE3_FUSION_PLANT,
    CardName_1.CardName.HE3_LOBBYISTS,
    CardName_1.CardName.HABITAT_14,
    CardName_1.CardName.HELIOSTAT_MIRROR_ARRAY,
    CardName_1.CardName.LUNA_RESORT,
    CardName_1.CardName.LUNA_SENATE,
    CardName_1.CardName.LUNAR_SECURITY_STATIONS,
    CardName_1.CardName.LUNAR_TRADE_FLEET,
    CardName_1.CardName.MICROSINGULARITY_PLANT,
    CardName_1.CardName.MOMENTUM_VIRUM_HABITAT,
    CardName_1.CardName.OFF_WORLD_CITY_LIVING,
    CardName_1.CardName.ORBITAL_POWER_GRID,
    CardName_1.CardName.ROVER_DRIVERS_UNION,
    CardName_1.CardName.SINUS_IRIDIUM_ROAD_NETWORK,
    CardName_1.CardName.THE_WOMB,
    CardName_1.CardName.TYCHO_ROAD_NETWORK,
    CardName_1.CardName.UNDERMOON_DRUG_LORDS_NETWORK,
    CardName_1.CardName.CORE_MINE,
    CardName_1.CardName.FIRST_LUNAR_SETTLEMENT,
    CardName_1.CardName.LUNA_FIRST_INCORPORATED,
];
//# sourceMappingURL=Engineer.js.map